import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from 'src/app/shared/shared.module';
import { ListTauxReconnaissanceComponent } from './list-tauxReconnaissance/list-tauxReconnaissance.component';
import { FilterTauxReconnaissanceByNamePipe } from 'src/app/shared/pipes/filter-tauxReconnaissance-by-name/filter-tauxReconnaissance-by-name.pipe';
import { ParametrageModule } from '../parametrage/parametrage.module';
import { TauxReconnaissanceModalDetailComponent } from './modal/tauxReconnaissance-modal-detail/tauxReconnaissance-modal-detail.component';
import { TauxReconnaissanceModalAjoutComponent } from './modal/tauxReconnaissance-modal-ajout/tauxReconnaissance-modal-ajout.component';

@NgModule({
	declarations: [
		ListTauxReconnaissanceComponent,
		TauxReconnaissanceModalDetailComponent,
		TauxReconnaissanceModalAjoutComponent
	],
	imports: [SharedModule, ParametrageModule],
	providers: [FilterTauxReconnaissanceByNamePipe]
})

export class TauxReconnaissanceModule {}
